export const megaMenuContent = {
    'admin':               'Admin',
    'announcement':        'Announcements',
    'apps':                'Apps',
    'architect':           'Architect',
    'apiDocs':             'API Docs',
    'attributeManagement': 'Attribute Management',
    'controlPanel':        'Control Panel',
    'client':              'Client',
    'company':             'Company',
    'conversions':         'Conversions',
    'equipment':           'Equipment',
    'executiveSummary':    'Executive Summary',
    'customCalculations':  'Calculated Sensors',
    'faults':              'Faults',
    'home':                'Home',
    'healthMonitor':       'Health Monitor',
    'iotHub':              'IoT Hub',
    'reporting':           'Reporting',
    'roles':               'Roles',
    'rules':               'Rules',
    'ruleBuilder':         'Rule Builder',
    'serviceRequests':     'Service Requests',
    'serviceManagement':   'Services',
    'sensors':             'Sensors',
    'settings':            'Settings',
    'subscriptions':       'Subscriptions',
    'system':              'System',
    'site':                'Site',
    'userProfile':         'User Profile',
    'userPermission':      'User Permission',
};
